import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavProgressBaseService } from 'app/services/navigation/nav-progress-base.service';
import { ParametreNavService } from 'app/services/parametre/parametre-nav.service';

/**
 * Barre de progression de navigation globale de l'ERP.
 *
 * Suit toutes les navigations SAUF les pages de paramétrage (`/main/parametre/**`),
 * déjà couvertes par {@link ParametreNavService} (barre dédiée à l'intérieur de la page).
 * Ainsi, un changement de page ERP (tickets, documents, factures, etc.) affiche une barre
 * de chargement cohérente en haut de l'application, comme dans le paramétrage.
 */
@Injectable({ providedIn: 'root' })
export class AppNavProgressService extends NavProgressBaseService {
  constructor(router: Router) {
    super(router);
  }

  protected shouldTrackUrl(url: string): boolean {
    return !ParametreNavService.isParametreUrl(url);
  }
}
